import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
import { BetreuerWorkDay } from './betreuerWorkDay';

export interface BetreuerWorkMonth {
    betrNr: number;
    workYear: number;
    workMonth: number;
    holidayHoursPrior: number;
    holidayHoursPriorS: string;
    holidayHoursNew: number;
    holidayHoursNewS: string;
    holidayHoursCurrent: number;
    holidayHoursCurrentS: string;
    overtimeHoursPrior: number;
    overtimeHoursPriorS: string;
    overtimeHoursNew: number;
    overtimeHoursNewS: string;
    overtimeHoursCurrent: number;
    overtimeHoursCurrentS: string;
    planTotal: number;
    actualTotal: number;
    isFinished: boolean;
    note: string;
    betreuerWorkDayList: BetreuerWorkDay[];
}

export interface BetreuerWorkMonthFilter {
    betrNr?: number;
    workYear?: number;
    workMonth?: number;
}

export function useBetreuerWorkMonthList(
    filter?: BetreuerWorkMonthFilter,
    apiOptions?: UseApiOptions<BetreuerWorkMonth[]>,
): QueryResult<BetreuerWorkMonth[]> {
    return useApi<BetreuerWorkMonth[]>(Controller.betreuerWorkMonth + '/list', { filter }, apiOptions);
}

export function useBetreuerWorkMonthOne(
    filter?: BetreuerWorkMonthFilter,
    apiOptions?: UseApiOptions<BetreuerWorkMonth>,
): QueryResult<BetreuerWorkMonth> {
    return useApi<BetreuerWorkMonth>(Controller.betreuerWorkMonth + '/one', { filter }, apiOptions);
}

export async function updateBetreuerWorkMonth(betreuerWorkMonth: BetreuerWorkMonth): Promise<void> {
    return callApi<void>(Controller.betreuerWorkMonth + '/update', { betreuerWorkMonth });
}

export async function initBetreuerWorkMonth(betrNr: number, workYear: number, workMonth: number): Promise<void> {
    return callApi<void>(Controller.betreuerWorkMonth + '/init', { betrNr, workYear, workMonth });
}

export async function finishBetreuerWorkMonth(betrNr: number, workYear: number, workMonth: number): Promise<void> {
    return callApi<void>(Controller.betreuerWorkMonth + '/finish', { betrNr, workYear, workMonth });
}
